import {
    atom,
} from 'recoil';

export const ChatMessages = atom({
    key: 'ChatMessages',
    default: {
        messages: [],
    },
})